angular.module('MktzapApp.Directives').directive('jsonText', function () {
  return {
    restrict: 'A',
    require: 'ngModel',
    link: function (scope, element, attr, ngModel) {
      function into (input) {
          	try {
          		out = JSON.parse(input);
          		$(element).css('background', '');
          		$(element).css('color', '');
          		return out
          	} catch (e) {
          		$(element).css('background', '#ff8282');
          		$(element).css('color', '#4a3d3d');
          		return undefined
          	}
      }
      function out (data) {
        return JSON.stringify(data, undefined, '    ');
      }
      ngModel.$parsers.push(into);
      ngModel.$formatters.push(out);
    }
  };
});
